export const canonicalParamsKey = (params = {}) =>
  JSON.stringify(
    params,
    Object.keys(params).sort((a, b) => a.localeCompare(b))
  );

const identifyingParams = (page) => {
  const params = page?.params ?? {};
  if (!page?.identityParams) {
    return params;
  }
  return page.identityParams.reduce(
    (kept, name) => ({ ...kept, [name]: params[name] }),
    {}
  );
};

export const pageIdentityKey = (page) =>
  page?.pageId
    ? `${page.pageId}|${canonicalParamsKey(identifyingParams(page))}`
    : null;

export const carriedBelongsToPage = (carried, page) =>
  Boolean(carried) &&
  carried.pageId === page?.pageId &&
  pageIdentityKey({ ...page, params: carried.pageParams }) ===
    pageIdentityKey(page);

export const pageContextKey = (page) =>
  page?.pageId
    ? `${page.pageId}|${canonicalParamsKey(page.params ?? {})}`
    : null;

export const pageContextOf = (page) => ({
  pageId: page?.pageId,
  params: page?.params ?? {},
  state: page?.state ?? {},
});

export const isConversationElsewhere = (page, conversation) => {
  if (!conversation?.pageId || !page?.pageId) {
    return false;
  }
  if (conversation.pageId !== page.pageId) {
    return true;
  }
  return Object.entries(conversation.pageParams ?? {}).some(
    ([name, value]) => page.params?.[name] !== value
  );
};
